export const CACHING_OPTIONS = {
  refetchInterval: 1000 * 60 * 15,
  refetchOnMount: false,
  staleTime: 1000 * 60 * 15,
};
